import React from 'react';

export default function About(){
  return (
    <div className="min-h-screen bg-gray-50">

      {/* Header with background and very bold text */}
      <header className="bg-teal-900 text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">Heartland Service Centre</h1>
          <p className="mt-3 text-lg md:text-xl font-semibold opacity-90">Confidential HIV self-testing & supportive linkage to care</p>
        </div>
      </header>

      <main className="max-w-6xl mx-auto p-6">
        {/* Text section */}
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">About</h2>
          <p className="text-lg md:text-xl font-semibold text-gray-800 leading-relaxed">Heartland Alliance LTD/GTE (HALG) is a service-based human rights organization with a global heritage, legally registered in Nigeria. We partner with governments, communities, civil society, and the private sector to expand access to healthcare, social justice, and economic empowerment for all.</p>
        </section>

        {/* What we offer */}
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">What we offer</h2>
          <div className="space-y-6 md:space-y-0 md:grid md:grid-cols-3 gap-6">
            <div className="p-6 bg-white rounded-lg shadow text-center">
              <h3 className="text-2xl font-extrabold text-red-700 mb-2">Self-test kits</h3>
              <p className="font-semibold text-gray-700">Rapid, easy-to-use kits you can use privately.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow text-center">
              <h3 className="text-2xl font-extrabold text-red-700 mb-2">Quick Response</h3>
              <p className="font-semibold text-gray-700">Secure verification and friendly support.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow text-center">
              <h3 className="text-2xl font-extrabold text-red-700 mb-2">Linkage to care</h3>
              <p className="font-semibold text-gray-700">Referrals to nearby clinics and care partners.</p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Contact</h2>
          <div className="p-6 bg-white rounded-lg shadow">
            <p className="text-lg font-semibold text-gray-800">If you have questions about orders, deliveries, or need support, reach out to our team. We prioritise privacy and fast responses.</p>
            <ul className="mt-4 space-y-2 text-lg font-semibold text-gray-800">
              <li><span className="font-bold">Phone:</span> +234 818 056 3191</li>
              <li><span className="font-bold">Email:</span> info@halghub.org</li>
              <li><span className="font-bold">Address:</span> Plot 459, L Close, Off 1st Avenue Gwarinpa,Abuja, FCT-Abuja. Nigeria.</li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  );
}
